import React, { useState, useEffect, useRef } from "react";

import "react-toastify/dist/ReactToastify.css";

var Modal = require("react-bootstrap-modal");

export const Terms = ({
  onNext,
  onPrev,
  formData,
  setFormData,
  className,
  save,
  updating,
}) => {
  const [stepForm, setStepForm] = useState({
    cancelationPolicy: formData.cancelationPolicy,
  });


  const valueRef = useRef(formData);

  const elementRef = useRef(null);

  
  useEffect(() => {
    valueRef.current = {...formData}
  }, [formData])
  
  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;
    
    const observer = new MutationObserver(() => {
      if (element.classList.contains('tw-hidden')) {
        handleComponentDisappear();
      }
    });
    
    observer.observe(element, {
      attributes: true,
      attributeFilter: ['class']
    });
    
    return () => observer.disconnect();
  }, []);

  const handleComponentDisappear = () => {
    setFormData(valueRef.current);
  };

  const handleStep = (tag, value) => {
    setStepForm({ ...stepForm, [tag]: value });
    valueRef.current = { ...formData, ...stepForm, [tag]: value };
  };
  const handleNextStep = (e) => {
    e.preventDefault();
    valueRef.current = {...formData, ...stepForm}
    setFormData({ ...formData, ...stepForm });
    setTimeout(() => {
      save(stepForm);
      onNext();
    }, 0); 
  };

  return (
    <form onSubmit={handleNextStep}>
      <div className={className}  ref={elementRef}>
        <div className=" my-3 tw-min-h-[60vh]">
          <h4 className="mb-5 tw-flex tw-justify-start tw-items-center">
            <span className="tw-bg-[#23426e] tw-mr-2 tw-flex tw-justify-center tw-items-center  tw-h-10 tw-w-10 tw-text-white  tw-rounded-full">
              9
            </span>{" "}
            Terms
          </h4>
          <div className="row col-lg-6 mb-2">
            <div className="mb-3">
              <label className="form-label">Select Cancellation Policy</label>
              <select
                onChange={(e) =>
                  handleStep("cancelationPolicy", e.target.value)
                }
                value={stepForm["cancelationPolicy"]}
                className="form-control wide"
                required
              >
                <option value="">Select</option>
                <option value="Relaxed">Relaxed</option>
                <option value="Moderate">Moderate</option>
                <option value="Strict">Strict</option>
              </select>
              {stepForm["cancelationPolicy"] === "Relaxed" && (
                <p className="tw-text-sm tw-text-gray-400 tw-my-2">
                  ⓘ Guests can receive a full refund up until 24 hours before
                  check-in
                </p>
              )}
              {stepForm["cancelationPolicy"] === "Moderate" && (
                <p className="tw-text-sm tw-text-gray-400 tw-my-2">
                  ⓘ Guests can receive a full refund up until 5 days before
                  check-in
                </p>
              )}
              {stepForm["cancelationPolicy"] === "Strict" && (
                <p className="tw-text-sm tw-text-gray-400 tw-my-2">
                  ⓘ No refunds
                </p>
              )}
            </div>
          </div>
        </div>
        <div>
          <button
            onClick={onPrev}
            type="button"
            className="btn btn-secondary mx-2  tw-mb-2"
          >
            Prev
          </button>

          <button
            type="submit"
            disabled={updating}
            className="btn btn-secondary tw-mb-2"
          >
            {updating ? "Updating ..." : "Save & Next"}
          </button>
        </div>
      </div>
    </form>
  );
};

export const validateTermsForm = (formData) => {
  const errors = [];

  if (!formData.cancelationPolicy || formData.cancelationPolicy.trim() === "") {
    errors.push({
      errorType: "cancelationPolicy",
      error: "Cancellation policy is required"
    });
  } else {
    const validPolicies = ["Relaxed", "Moderate", "Strict"];
    if (!validPolicies.includes(formData.cancelationPolicy)) {
      errors.push({
        errorType: "cancelationPolicy",
        error: "Please select a valid cancellation policy"
      });
    }
  }

  return {isValid: errors.length === 0, errors};
};